// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1tER9","col":"styles_col__28mdl","fulfillmentStatus":"styles_fulfillmentStatus__2I2BM","emailCol":"styles_emailCol__1dy-g"};